import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, share, tap } from 'rxjs/operators';
import { resourceLoaderFactory } from './resource-loader.factory';
import { L10nTranslationService } from 'angular-l10n';
import { MiqSecuredResourcesConfig, SECURED_RESOURCES_CONFIGS_TOKEN } from './miq-secured-resources.token';

@Injectable()
export class MiqSecuredResourcesService {
  private _imageCache = {};
  resolverService: Function;

  constructor(
    @Inject(SECURED_RESOURCES_CONFIGS_TOKEN) private securedResourcesConfig: MiqSecuredResourcesConfig,
    private http: HttpClient,
    public translationService: L10nTranslationService
  ) {
    const simpleBlobCreator = e => URL.createObjectURL(e);
    this.resolverService = resourceLoaderFactory(this.http, simpleBlobCreator);
  }

  loadImage(rawURI: string, params = { responseType: 'blob' }, prependS3Uri: boolean = false): Observable<Object> {
    const uri = prependS3Uri ? `${this.securedResourcesConfig.s3Path}${rawURI}` : rawURI;
    if (this._imageCache[uri]) {
      const isObservable = typeof this._imageCache[uri].subscribe === 'function';
      return isObservable ? this._imageCache[uri] : of(this._imageCache[uri]);
    }
    this._imageCache[uri] = this.resolverService(uri, params).pipe(
      tap(response => (this._imageCache[uri] = response)),
      catchError(() => {
        this._imageCache[uri] = this.securedResourcesConfig.buildingPhName;
        throw new Error(this.translationService.translate('shared.couldNotRetrieveImage'));
      }),
      share()
    );
    return this._imageCache[uri];
  }

  downloadImage(rawURI: string, prependS3Uri: boolean = false) {
    const uri = prependS3Uri ? `${this.securedResourcesConfig.s3Path}${rawURI}` : rawURI;
    return this.http.get(uri, { responseType: 'blob', observe: 'response' }).pipe(
      map(({ body }) => ({
        blob: body,
      })),
      catchError(() => {
        throw new Error(this.translationService.translate('shared.errorWhileDownloadImage'));
      })
    );
  }
}
